import { createContext, useContext } from "react";
//#region src/ui/volume-popover/context.tsx
const VolumePopoverContext = createContext(null);
const VolumePopoverContextProvider = VolumePopoverContext.Provider;
function useVolumePopoverContext() {
	const context = useContext(VolumePopoverContext);
	if (!context) throw new Error("VolumePopover compound components must be used within a VolumePopover.Root");
	return context;
}
//#endregion
export { VolumePopoverContextProvider, useVolumePopoverContext };

//# sourceMappingURL=context.js.map